export default __webpack_public_path__ + "static/media/download-black.0b9b1197.svg";